import { Component, Input } from '@angular/core';
import { InternalMsgService } from '../shared/internal.msg.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-str-spinner',
    templateUrl: './cafs-spinner.component.html',
    styleUrls: ['./cafs-spinner.component.css']
})
export class CafsSpinnerComponent {
    @Input() message: string = '';

    msgSubscr!: Subscription;
    isVisible: boolean = false;

    constructor(private msgService: InternalMsgService) { }

    ngOnInit(): void {
        this.msgSubscr = this.msgService.toggleSpinnerSet$.subscribe(isLoading => {
            this.isVisible = isLoading;
        });    
    }

    getMessage(): string {
        return this.message.trim() == ''
            ? 'Please wait, data is being handled'
            : this.message;
    }
}
